module.exports = __webpack_public_path__ + "img/IMG_2154.6a73b4d5.jpg";